import React from 'react';
import './Loader.css';

const Loader = props => {
  return (
    <div className="loader"></div>
  )
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js